export enum NotificationBarCallbackReason {
    PrimaryActionClicked,
    SecondaryActionClicked,
    DismissClicked,
    AutoDismissed,
    MouseLeaveAfterTimerCompleted,
    NotificationBarUnmounted,
}
